import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "4",
  y: "7.291",
  width: "12.831",
  height: "12.709",
  rx: "4",
  stroke: "#333",
  "stroke-width": "1.5"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.747 7.89a3.976 3.976 0 0 1 1.76-.584A3.25 3.25 0 0 1 10.419 5.5h4.831a3.25 3.25 0 0 1 3.25 3.25v4.708a3.25 3.25 0 0 1-1.835 2.927 3.976 3.976 0 0 1-.601 1.754A4.751 4.751 0 0 0 20 13.459v-4.71A4.75 4.75 0 0 0 15.25 4H10.42a4.751 4.751 0 0 0-4.672 3.89Z",
  fill: "#333"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };